import angular   from 'angular';
import cloneDeep from 'clone-deep';
import view      from './view.html';

/* @ngInject */
export default function () {
	return {
		replace:                    true,
		template:                   view,
		scope:                      {
			onDocumentSelected: '=?',
			selectedDocumentId: '=',
		},
		controller: /* @ngInject */ ($scope, DocumentsDirectories, STATUSES, toastr) => {
			const indexDirectory = (directory, parentId) => {
				if (directory.children !== undefined && directory.documents !== undefined) {
					$scope.directoriesById[directory.id] = {
						...cloneDeep(directory),
						parent:    parentId,
						children:  directory.children.map((child) => {
							return child.id;
						}),
						documents: directory.documents.map((document) => {
							return document.id;
						}),
					};
				} else {
					// Potentially update just name?
				}
			};

			const indexDocument = (document, parentId) => {
				$scope.documentsById[document.id] = {
					...cloneDeep(document),
					parent: parentId,
				};
			};

			const recursivelyIndexDirectoriesById = (directories, parentId) => {
				angular.forEach(directories, (directory) => {
					indexDirectory(directory, parentId);

					angular.forEach(directory.documents, (document) => {
						indexDocument(document, directory.id);
					});

					recursivelyIndexDirectoriesById(directory.children, directory.id);
				});
			};

			const indexEntitiesById = (directories) => {
				recursivelyIndexDirectoriesById(directories, null);
			};

			$scope.directoriesById = {};
			$scope.documentsById   = {};

			$scope.status = STATUSES.UNLOADED;
			$scope.data   = null;

			$scope.selectedTreeDocumentId = null;

			$scope.refreshDirectory = (directoryId) => {
				// These changes have been made to lazy load documents in the selected directory, which allows the backend to remain performant

				DocumentsDirectories.one(directoryId)
				                    .get({
					                    include: 'children,documents.latestVersion,parent',
				                    })
				                    .then((data) => {
					                    const normalizeDirectory = (directory) => {
						                    if (directory.children === undefined) {
							                    directory.children = [];
						                    }

						                    if (directory.documents === undefined) {
							                    directory.documents = [];
						                    }

						                    if (directory.parent !== undefined) {
							                    directory.parent = directory.parent.id;
						                    } else {
							                    directory.parent = null;
						                    }

						                    return directory;
					                    };

					                    const directory = normalizeDirectory(data);

					                    recursivelyIndexDirectoriesById(
						                    [
							                    directory,
						                    ],
						                    directory.parent,
					                    );

					                    const mergedTreeData = {
						                    ...$scope.directoriesById,
						                    ...$scope.documentsById,
					                    };

					                    $scope.data = mergedTreeData;

					                    $scope.refreshOnUpdate = directoryId;
				                    })
				                    .catch((error) => {
					                    // Ignore as this "directory" was actually a document
				                    });
			};

			$scope.refresh = () => {
				$scope.status = STATUSES.LOADING;
				$scope.data   = null;

				DocumentsDirectories.getList({
					include: 'descendants,documents',
				})
				                    .then((data) => {
					                    const moveDescendantsToChildren = (rootDirectories) => {
						                    let directories = [];

						                    angular.forEach(rootDirectories, (rootDirectory) => {
							                    let directory = cloneDeep(rootDirectory);

							                    if (rootDirectory.descendants !== undefined) {
								                    directory.children = [
									                    ...cloneDeep(rootDirectory.descendants),
								                    ];

								                    delete directory.descendants;
							                    } else if (rootDirectory.children === undefined) {
								                    directory.children = [];
							                    }

							                    if (rootDirectory.documents === undefined) {
								                    directory.documents = [];
							                    }

							                    directories.push(directory);
						                    });

						                    return directories;
					                    };

					                    const normalizeDirectories = (rootDirectories) => {
						                    let directories = [];

						                    angular.forEach(rootDirectories, (rootDirectory) => {
							                    if (rootDirectory.children === undefined) {
								                    rootDirectory.children = [];
							                    } else {
								                    rootDirectory.children = normalizeDirectories(rootDirectory.children);
							                    }

							                    if (rootDirectory.documents === undefined) {
								                    rootDirectory.documents = [];
							                    }

							                    directories.push(rootDirectory);
						                    });

						                    return directories;
					                    };

					                    let directories = moveDescendantsToChildren(data);

					                    directories = normalizeDirectories(directories);

					                    indexEntitiesById(directories);

					                    const mergedTreeData = {
						                    ...$scope.directoriesById,
						                    ...$scope.documentsById,
					                    };

					                    $scope.data = mergedTreeData;

					                    $scope.status = STATUSES.LOADED;

					                    $scope.refreshOnUpdate = (new Date()).getTime();
				                    })
				                    .catch((error) => {
					                    toastr.clear();
					                    toastr.error('There was an error while loading the directory tree, please try again.', 'Error');

					                    $scope.status = STATUSES.ERRORED;
				                    });
			};

			$scope.baseOnDocumentSelected = (documentId) => {
				$scope.selectedDocumentId = documentId;

				$scope.refreshDirectory(documentId);

				if ($scope.onDocumentSelected) {
					$scope.onDocumentSelected(documentId);
				}
			};

			if ($scope.selectedDocumentId) {
				$scope.selectedTreeDocumentId = $scope.selectedDocumentId;
			}

			$scope.refresh();
		},
		link:                       (scope, element, attrs) => {

		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/directoryTreeSelectDocument/index.js